import { render, staticRenderFns } from "./PreditivaDialCampaign.vue?vue&type=template&id=884afc3e&scoped=true"
import script from "./PreditivaDialCampaign.vue?vue&type=script&lang=js"
export * from "./PreditivaDialCampaign.vue?vue&type=script&lang=js"
import style0 from "./PreditivaDialCampaign.vue?vue&type=style&index=0&id=884afc3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "884afc3e",
  null
  
)

export default component.exports